/*!
 * vue-selection-controller v0.10.19 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { updateValue, prepareData, resultValue } from '@aspectus/selection-controller';
import { renderSlim } from '@aspectus/vue-utils';
import { Tag } from '@aspectus/vue-tag';

var SelectionController = {
  name: 'vue-selection-controller',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {},
    options: {},
    keyGetter: Function,
    updator: {
      type: Function,
      default: updateValue
    },
    states: Object
  },
  computed: {
    prepared: function prepared() {
      return prepareData(this.options, this.value, this.keyGetter, this.states);
    }
  },
  methods: {
    change: function change(_change) {
      var value = this.updator(_change, this.prepared.value, this.keyGetter, this.multiple);
      this.$emit('input', resultValue(value, this.multiple));
    }
  },
  render: function render(h) {
    var change = this.change,
        multiple = this.multiple,
        keyGetter = this.keyGetter;
    var _this$prepared = this.prepared,
        value = _this$prepared.value,
        options = _this$prepared.options;
    return renderSlim(this.$scopedSlots.default({
      value: value,
      options: options,
      multiple: multiple,
      change: change,
      keyGetter: keyGetter
    }), h, Tag);
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? SelectionController.name : _ref$name;

  Vue.component(name, SelectionController);
}

var main = {
  install: install
};

export default main;
export { SelectionController };
